import * as THREE from 'three'

/*
 *  This custom cone geometry has the rotation point set at its
 *  vertex, opposed to the center of the cone in THREE.ConeGeometry.
 */
class CustomConeGeometry extends THREE.BufferGeometry {
  constructor(radiusTop, height, radialSegments) {
    super()
    
    // buffers
    var indices = [];
    var vertices = [];
    var normals = [];
    var uvs = [];

    // helper variables
    var index = 0;
    var indexArray = [];

    // generate geometry
    generateTorso();

    // build geometry
    this.setIndex( indices );
    this.setAttribute( 'position', new THREE.Float32BufferAttribute( vertices, 3 ) );
    this.setAttribute( 'normal', new THREE.Float32BufferAttribute( normals, 3 ) );
    this.setAttribute( 'uv', new THREE.Float32BufferAttribute( uvs, 2 ) );

    function generateTorso() {
      var x, y;
      var normal = new THREE.Vector3();
      var vertex = new THREE.Vector3();

      // this will be used to calculate the normal
      var slope = radiusTop / height;

      // generate vertices, normals and uvs
      for ( y = 0; y <= 1; y ++ ) {
        var indexRow = [];

        var v = y / 1;

        // calculate the radius of the current row
        var radius = v * radiusTop;

        for ( x = 0; x <= radialSegments; x ++ ) {
          var u = x / radialSegments;

          var theta = u * Math.PI * 2;

          var sinTheta = Math.sin( theta );
          var cosTheta = Math.cos( theta );

          // vertex
          vertex.x = radius * sinTheta;
          vertex.y = v * height;
          vertex.z = radius * cosTheta;
          vertices.push( vertex.x, vertex.y, vertex.z );

          // normal
          normal.set( sinTheta, slope, cosTheta ).normalize();
          normals.push( normal.x, normal.y, normal.z );

          // uv
          uvs.push( u, 1 - v );

          // save index of vertex in respective row
          indexRow.push( index ++ );
        }

        // now save vertices of the row in our index array
        indexArray.push( indexRow );
      }

      // generate indices
      for ( x = 0; x < radialSegments; x ++ ) {

        for ( y = 0; y < 1; y ++ ) {

          // we use the index array to access the correct indices
          var a = indexArray[ y ][ x ];
          var b = indexArray[ y + 1 ][ x ];
          var c = indexArray[ y + 1 ][ x + 1 ];
          var d = indexArray[ y ][ x + 1 ];

          // faces
          indices.push( a, b, d );
          indices.push( b, c, d );
        }
      }
    }
  }
}

export default CustomConeGeometry